import { getPDPUrl } from 'utils/product';
import { makeBuylistUrl } from 'utils/adtech/links';
import { type BannerLink } from 'types/adtech';
import { type CitrusProduct } from './transform-searchresult-to-tradingcell-props';

export function getBannerUrl(url: string | undefined, products: CitrusProduct[]) {
  if (url) return url;

  if (products.length === 1) {
    const [product] = products;
    const { id, name } = product;

    return getPDPUrl(id, name) || '';
  }

  return makeBuylistUrl(products);
}

export type RequiredBannerLink = BannerLink & { text: string };

export const emptyLink: RequiredBannerLink = { text: '', url: '', altText: '' };

export function generateBannerLink(
  citrusLink = '',
  products: CitrusProduct[],
  linkText = 'Shop now',
  isExternalLink?: boolean,
): RequiredBannerLink | Record<PropertyKey, never> {
  const url = getBannerUrl(citrusLink, products);

  // Handle edge case where link hasn't been generated as expected.
  if (!url) return emptyLink;

  return {
    url,
    text: linkText,
    altText: linkText,
    ...(isExternalLink !== undefined && {
      isExternalLink,
    }),
  };
}
